import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Linker from '@/components/base/Linker';
import { gettext } from '@/utils/langsBook';
import { makeBlockDetailLink, makeDAppContract } from '@/utils/link';
import { toContractID, toUTCDay } from '@/utils/string';
export var PAGE_SIZE = 21;
export var MANAGED_PAGE_SIZE = 9;
export var getContractColumns = function(address) {
    return [
        {
            key: 'Contract ID',
            title: gettext('Contract ID'),
            render: function(row) {
                return toContractID(row === null || row === void 0 ? void 0 : row.CID);
            }
        },
        {
            key: 'Contract Name',
            title: gettext('Contract Name'),
            render: function(row) {
                /*#__PURE__*/ return _jsx(Linker, {
                    href: makeDAppContract(address, row.Contract),
                    children: row.Contract
                });
            }
        },
        //   key: 'Version',
        //   title: gettext('Version'),
        //   render: (row: DIOX.DAppContract) => `${row.LastVersion}`,
        // },
        {
            key: 'Last Deployment',
            title: gettext('Last Deployment'),
            render: function(row) {
                /*#__PURE__*/ return _jsxs("div", {
                    children: [
                        toUTCDay(row.LastDeployment),
                        "(",
                        /*#__PURE__*/ _jsx(Linker, {
                            href: makeBlockDetailLink(row.BlockHash),
                            text: "#".concat(row.Height)
                        }),
                        ")"
                    ]
                });
            }
        }
    ];
};
